var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33333 8H12.6667",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 3.33333V12.6667",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePlusIcon);
export default __webpack_public_path__ + "static/media/table-plus-icon.edff8d4799be5b325a7b3001d0ba0f51.svg";
export { ForwardRef as ReactComponent };